import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.featured-brands-slider' ).each( ( key, marquee ) => {
        new Splide( marquee, {
          destroy: true,
          type: 'loop',
          autoWidth: true,
          arrows: false,
          gap: '0',
          breakpoints: {
            768: {
              destroy: false,
              perPage: 1,
            },
          },
          pagination: false,
        } ).mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-brands', COMPONENT );
} )( app );
